import React from 'react'

import FormControlled from 'common/Forms/Base/FormControlled'
import ReactSelect from 'common/ReactSelect'

export default props => <FormControlled tag={ReactSelect} {...props} />
